import { render, staticRenderFns } from "./ClicMultiselect.vue?vue&type=template&id=beca7658&"
import script from "./ClicMultiselect.vue?vue&type=script&lang=js&"
export * from "./ClicMultiselect.vue?vue&type=script&lang=js&"
import style0 from "./ClicMultiselect.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports